/**
 * @generated SignedSource<<c1ffc28747abddad77d9476025c24d7b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type BasicMetadata = {
  description?: string | null | undefined;
  title: string;
};
export type AclItem = {
  actions: ReadonlyArray<string>;
  role: string;
};
export type CreatePlaylistMutation$variables = {
  acl: ReadonlyArray<AclItem>;
  creator: string;
  entries: ReadonlyArray<string>;
  metadata: BasicMetadata;
};
export type CreatePlaylistMutation$data = {
  readonly createPlaylist: {
    readonly id: string;
  };
};
export type CreatePlaylistMutation = {
  response: CreatePlaylistMutation$data;
  variables: CreatePlaylistMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "acl"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "creator"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "entries"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "metadata"
},
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "acl",
        "variableName": "acl"
      },
      {
        "kind": "Variable",
        "name": "creator",
        "variableName": "creator"
      },
      {
        "kind": "Variable",
        "name": "entries",
        "variableName": "entries"
      },
      {
        "kind": "Variable",
        "name": "metadata",
        "variableName": "metadata"
      }
    ],
    "concreteType": "AuthorizedPlaylist",
    "kind": "LinkedField",
    "name": "createPlaylist",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CreatePlaylistMutation",
    "selections": (v4/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "CreatePlaylistMutation",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "c93b6c8857d2552d98aafd81b1f2f1b7",
    "id": null,
    "metadata": {},
    "name": "CreatePlaylistMutation",
    "operationKind": "mutation",
    "text": "mutation CreatePlaylistMutation(\n  $metadata: BasicMetadata!\n  $acl: [AclItem!]!\n  $creator: String!\n  $entries: [ID!]!\n) {\n  createPlaylist(metadata: $metadata, acl: $acl, creator: $creator, entries: $entries) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "c3d5e2a05d55bec9e6bbcad13a5811c7";

export default node;
